import CloseIcon from "@mui/icons-material/Close";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import { styled } from "@mui/material/styles";
import PropTypes from "prop-types";
import * as React from "react";
import { connect } from "react-redux";
import DynamicTable from "../../../components/Comman/RT/MaterialUIRTTable";
import DynamicDetails from "../../../components/dynamicscreens/DynamicDetails";
import { imageUrl } from "../../../config/Url";
import { showNotification } from "../../Landing/Landing.slice";
import { Box, Grid } from "@mui/material";
import { LabelCompo } from "../../../components/Comman/Label";
import { MyComponentWithIconProps } from "../../../components/Comman/IconButton";
import { titleColor } from "../../../config/ColorObj";
import VisibilityIcon from "@mui/icons-material/Visibility";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { classes, children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

const LeaveAnalysisPopUp = ({
  handleCloses,
  open,
  columns,
  rows,
  viewHeaderData,
  DataToSet,
  fixedCalculation,
  showNotification,
  dataToSend,
}) => {
  const handleClose = () => {
    handleCloses();
  };

  return (
    <>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        fullWidth
        maxWidth="lg"
      >
        <BootstrapDialogTitle
          id="customized-dialog-title"
          onClose={handleClose}
        >
          Leave Analysis
        </BootstrapDialogTitle>

        <DynamicDetails DataToSet={DataToSet} />

        <DialogContent dividers>
          <DynamicTable
            data={rows}
            tableHead={columns}
            showPegination={false}
            isActionColActive={false}
          />
        </DialogContent>
      </BootstrapDialog>
    </>
  );
};
const mapStateToProps = (state) => ({});

const mapDispatchToProps = { showNotification };

export default connect(mapStateToProps, mapDispatchToProps)(LeaveAnalysisPopUp);
